import { API_MAX_RESULTS } from "@consts";
import { getSearchParamsFromRoute } from "@utils";
import { getRequestMediator } from "~/common/modules/request-mediator";
import { getServiceEndpointProvider } from "~/common/modules/service-endpoint-provider";

export default {
	async onSeeMoreButtonClick(buttonMode) {
		if (buttonMode === "All") {
			if (!this.tableWordsExtended.length) {
				const requestMediator = getRequestMediator(
					this.$route,
					getServiceEndpointProvider(this.$axios, this.$config)
				);

				const params = getSearchParamsFromRoute(this.$route);

				this.loadingMoreWords = true;
				const response = await requestMediator.get(params.clean, {
					word_length: this.wordLength,
					offset: 35,
					limit: API_MAX_RESULTS,
					order_by:
						params.clean?.misc?.order_by ||
						this.currentSort ||
						"score",
				});
				this.loadingMoreWords = false;

				const augmentedResults = requestMediator?.formatResults(
					response?.data?._augment?._groups || []
				);

				const results = requestMediator?.formatResults(
					response?.data?._groups || []
				);

				const mappedResult = results[this.wordLength]?._items || [];
				const mappedAugmented =
					augmentedResults[this.wordLength]?._items || [];

				this.tableWordsExtended = [...mappedResult, ...mappedAugmented];
			}
			this.itemsToShow = API_MAX_RESULTS;
		} else if (buttonMode === "More") {
			this.itemsToShow = this.secondWordCount;
		} else if (buttonMode === "Less") {
			window.scrollTo(0, this.$el.offsetTop - 185);
			this.itemsToShow = this.initialWordsCount;
		}
	},
	highlightWord(word, mod) {
		if (typeof word !== "string") {
			return "";
		}
		if (typeof mod !== "string") {
			return word;
		}
		let highlighted = mod
			.split("")
			.map((m, i) => {
				const letter = word[i];
				return m === "r" ? letter : `<strong>${letter}</strong>`;
			})
			.join("");
		highlighted = highlighted.replace(/<\/strong><strong>/g, "");
		return highlighted;
	},
	onLoadWords(params) {
		this.$router.push({ query: { ...this.$route.query, ...params } });
	},
	isCommerceWidget(placement) {
		return (
			this.$store.getters["navigation/isCommerceWidgetPage"] &&
			placement === "mob_in_list_1"
		);
	},
	handleOpenedDef(wordIndex) {
		this.$set(this.definitionStates, wordIndex, true);
	},
	handleClosedDef(wordIndex) {
		this.$set(this.definitionStates, wordIndex, false);
	},
};
